import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterTaskItemsValue,
  UniversalFilterTaskItemsModes,
  UniversalFilterTaskItemsFilterState,
  UniversalFilterTaskItemsOnChange
} from '../../UniversalFilterTaskItems.types';

interface UniversalFilterTaskItemsFilterStateOptions {
  onChange: UniversalFilterTaskItemsOnChange;
}

function useUniversalFilterTaskItemsFilterState({
  onChange
}: UniversalFilterTaskItemsFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterTaskItemsFilterState) => void
  >(
    (filterState) => {
      const itemNames = filterState?.itemNames;

      if (filterState?.mode === UniversalFilterTaskItemsModes.CONTAINS_ALL_OF) {
        onChange(isEmpty(itemNames) ? undefined : { in: itemNames });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterTaskItemsValue
    ) => UniversalFilterTaskItemsFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue)) {
      return {
        mode: UniversalFilterTaskItemsModes.CONTAINS_ALL_OF,
        itemNames: filterValue?.in || []
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterTaskItemsFilterState;
